import { useToasts } from "@skailer-com/uikit";
import { useCallback } from "react";
import { ErrorCode, FileRejection } from "react-dropzone";

interface UseFileDropzoneOptions {
  tooManyFilesMessage?: string;
  unsupportedFileFormatMessage?: string;
}

interface UseFileDropzoneResult {
  onDropRejected: (fileRejections: FileRejection[]) => void;
}

export function useFileDropzone({
  tooManyFilesMessage,
  unsupportedFileFormatMessage,
}: UseFileDropzoneOptions): UseFileDropzoneResult {
  const { showError } = useToasts();

  const onDropRejected = useCallback(
    (fileRejections: FileRejection[]) => {
      const hasTooManyFilesError = fileRejections.some((rejection) =>
        rejection.errors.some((error) => error.code === ErrorCode.TooManyFiles)
      );

      if (hasTooManyFilesError && tooManyFilesMessage) {
        showError({ title: tooManyFilesMessage });
        return;
      }

      if (unsupportedFileFormatMessage) {
        showError({ title: unsupportedFileFormatMessage });
      }
    },
    [showError, tooManyFilesMessage, unsupportedFileFormatMessage]
  );

  return {
    onDropRejected,
  };
}
